import request from '@/utils/request'; // 假设 request.ts 位于 utils 目录下

// --- 接口定义 ---

/**
 * 获取新闻列表
 * @param params 查询参数 (lang, page, size, category_id)
 */
export const getNewsListApi = (params: { lang: string, page: number, size: number, category_id?: number | null }) => {
    return request.get('/v1/news/list', params);
};
export const getNewsCategoryApi = (params: { lang: string}) => {
    return request.get('/v1/news/categories', params);
};
export const getNewsDetailApi = (news_id: number, params: { lang: string }) => {
    // 修正：request.get的第二个参数是config对象，参数需要放在params属性中
    return request.get(`/v1/news/${news_id}`,  params);
};

/**
 * 获取公告列表
 * @param params 查询参数 (lang, page, size, category_id)
 */
export const getNoticeListApi = (params: { lang: string, page: number, size: number, category_id?: number | null }) => {
    return request.get('/v1/notice/list', params);
};
export const getNoticeCategoryApi = (params: { lang: string}) => {
    return request.get('/v1/notice/categories', params);
};
/**
 * 获取公告详情
 * @param notice_id 公告ID
 * @param params 查询参数 (lang)
 */
export const getNoticeDetailApi = (notice_id: number, params: { lang: string }) => {
    return request.get(`/v1/notice/${notice_id}`, params);
};

export const getSinglePageContent = (params: { lang: string, path: string }) => {
    return request.get(`/v1/page/content`, params);
};

export const getHomeConfigApi = (params: { lang: string }) => {
    return request.get(`/v1/home/config`, params);
};

export const getRecruitmentList = (params: { lang: string }) => {
    return request.get(`/v1/recruitment/list`, params);
};

export const getRecruitmentDetail = (recruitment_id: number, params: { lang: string }) => {
    return request.get(`/v1/recruitment/${recruitment_id}`, params);
};

export const getRecruitmentIntro = (params: { lang: string }) => {
    return request.get(`/v1/recruitment/intro`, params);
}